module.exports = __webpack_public_path__ + "static/seostorm-bc56b6b8a182052a8ff3eb6280618439.svg";